"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const query_string_1 = __importDefault(require("query-string"));
class ModuleEditorParamsUtils {
    static getQueryString() {
        return query_string_1.default.parse(window.location.search);
    }
}
ModuleEditorParamsUtils.getExtraParam = () => {
    const queryString = ModuleEditorParamsUtils.getQueryString();
    const isExtraModule = queryString.extra === 'true';
    return isExtraModule;
};
ModuleEditorParamsUtils.getExtraPaidParam = () => {
    const queryString = ModuleEditorParamsUtils.getQueryString();
    const isPaidModule = queryString.extraPaid === 'true';
    return isPaidModule;
};
ModuleEditorParamsUtils.getSeasonParam = () => {
    const queryString = ModuleEditorParamsUtils.getQueryString();
    const season = queryString.season ? queryString.season : null;
    return season;
};
exports.default = ModuleEditorParamsUtils;
